import * as React from "react";
const SvgDownload = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	height: "24px",
	viewBox: "0 0 24 24",
	width: "24px",
	fill: "currentColor",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M0 0h24v24H0z",
	fill: "none"
}), /* @__PURE__ */ React.createElement("path", { d: "M16 13h-3V3h-2v10H8l4 4 4-4zM4 19v2h16v-2H4z" }));
export default SvgDownload;
